<template>
  <ItemsTable
    title="Available Workspaces"
    :headers="headers"
    :rows="displayRows"
    :get-data="getData"
    :has-more-data="hasMoreData"
    :is-loading="isLoading && !showSkeletons"
    :class="{ 'skeleton-loading': showSkeletons }"
    @clickRow="highlightRow"
  />
</template>
<script>
import ItemsTable from '../table/items-table';

const DEFAULT_SKELETON_COUNT = 3;

export default {
  name: 'TeamsTable',
  components: {
    ItemsTable,
  },
  props: {
    selectedTeamId: { type: String, required: true },
  },
  data() {
    return {
      previousTeamCount: 0,
    };
  },
  computed: {
    headers() {
      return [{ key: 'name' }];
    },
    rows() {
      return this.$store.state.teams.teams.map(({ name, id }) => ({
        id,
        name,
        isSelected: this.selectedTeamId === id,
      }));
    },
    hasMoreData() {
      return this.$store.getters['teams/hasMoreTeams'];
    },
    isLoading() {
      return this.$store.state.teams.isLoadingGetTeams;
    },
    showSkeletons() {
      return this.isLoading && this.rows.length === 0;
    },
    skeletonCount() {
      return this.previousTeamCount || DEFAULT_SKELETON_COUNT;
    },
    displayRows() {
      if (this.showSkeletons) {
        return Array.from({ length: this.skeletonCount }, (_, i) => ({
          id: `skeleton-${i}`,
          name: '\u00A0',
          isSelected: false,
        }));
      }
      return this.rows;
    },
  },
  created() {
    this.previousTeamCount = this.$store.state.teams.teams.length;
    this.$store.dispatch('teams/refreshGetTeams');
  },
  methods: {
    highlightRow({ id }) {
      if (this.showSkeletons) return;
      this.$emit('onClickRow', id);
    },
    getData() {
      if (this.hasMoreData) {
        return this.$store.dispatch('teams/getTeams');
      }
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
.skeleton-loading ::v-deep .table-row {
  pointer-events: none;
  td .table-cell-content-wrapper > div {
    color: transparent;
    display: inline-block;
    height: 0.875em;
    width: 45%;
    background: linear-gradient(90deg, #ebebeb 25%, #dedede 50%, #ebebeb 75%);
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
    border-radius: 4px;
  }
  &:nth-child(even) td .table-cell-content-wrapper > div {
    width: 35%;
  }
  &:nth-child(3n) td .table-cell-content-wrapper > div {
    width: 55%;
  }
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
